    <!-- 発注処理画面 -->
<template>
  <div>
    <ListDialog ref="createPurchaseOrderFromCommodityDialog" title="発注処理" :buttonNames="buttonNames" :captions="['商品','SKU','予定在庫数量','補充基準数量','補充数量','補充単位','単価','税区分','回答納期','入荷予定日']" :widths="[150,150,100,100,150,150,150,150,150,150]" :showAdd="false" :showRemove="true" :execWithIndex="SubmitCreatePurchaseOrder" :height="235" :width="1000" @closeDialog="$emit('hidden')">
        <template slot="header" slot-scope="{ editor }">
          <EditPanel>
          <template slot="left">
            <ComboBox title="ワークフロー" :value.sync="cpoWorkflowId" :editor="editor" list="workflow_purchaseOrder" :required="$api.perms.hasWorkflow('purchaseOrder')" :enabled="$api.perms.hasWorkflow('purchaseOrder')" :nullValue="0" @changed="onChangeWorkflow()" tooltip="発注時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【発注管理】になっているデータから選択ができます。"/>          
            <AtcSegment title="部門" :value.sync="cpoSegment" :editor="editor" :required="true" tooltip="発注を担当する部門を選択します。【部門一覧】のデータから選択することができます。" />
            <AutoComplete title="担当者" :value.sync="cpoPic" :editor="editor" list="user" :required="true" tooltip="案件を担当する人を選択します。【ユーザー】のデータを選択することができます。"/>
            <CheckBox title="既存の発注に追加" :value.sync="cpoAddExistPurchaseOrder" list="addFlags" :editor="editor" tooltip="同一の発注先への未確定発注伝票がある場合、その発注伝票へ明細を追加します。部門・担当者が一致する必要があります。" />
            <AtcCounterpart title="仕入先(未指定分)" :value.sync="cpoSupplier" :editor="editor" :needsSupplier="true" :required="true" v-if="cpoSupplierEnabled" tooltip="商品に【仕入先】の指定がない場合に、発注先を指定します。" />
          </template>
          </EditPanel>
        </template>
      <!-- 入荷処理ダイアログ 一覧項目 -->
      <TextBox slot="col0" slot-scope="{ item, editor }" :value="item.commodity.name" :editor="editor" :enabled="false" />
      <TextBox slot="col1" slot-scope="{ item, editor }" :value="item.sku?item.sku.name:''" :editor="editor" :enabled="false" />
      <NumericBox slot="col2" slot-scope="{ item, editor }" :value="item.scheduleQuantity" :editor="editor" :enabled="false" :decimals="item.commodity.quantityScale"/>
      <NumericBox slot="col3" slot-scope="{ item, editor }" :value="item.minimumStockQuantity" :editor="editor" :enabled="false" :decimals="item.commodity.quantityScale"/>
      <NumericBox slot="col4" slot-scope="{ item, editor }" :value.sync="item.purchaseReplenishmentQuantity" :editor="editor" :enabled="true" :decimals="item.commodity.quantityScale" :required="true" min='0' max='99999999.999' :nullValue="0" @update:value="getPriceAndTaxCode(item)" />
      <AtcConversion slot="col5" slot-scope="{ item, editor }" :value.sync="item.dialogPurchaseReplenishmentUom" :editor="editor" :enabled="true" :commodity="item.commodity"/>
      <NumericBox slot="col6" slot-scope="{ item, editor }" :editor="editor" :enabled="true" :value.sync="item.unitPrice" :required="!tenantSettings.noCheckPriceRequired" min="-999999999.999999" max="999999999.999999" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" />
      <AtcTaxCode slot="col7" slot-scope="{ item, editor }" :editor="editor" :enabled="true" :value.sync="item.taxCode" :taxType="getTaxType(item)" list="taxCode" :required="true" />
      <Calendar slot="col8" slot-scope="{ item, editor }" :editor="editor" :enabled="true" :value.sync="item.answerDeliveryDate" :deletable="true" />
      <Calendar slot="col9" slot-scope="{ item, editor }" :editor="editor" :enabled="true" :value.sync="item.scheduledDeliveryDate" :deletable="true" />
    </ListDialog>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class CreatePurchaseOrderFromCommodity extends Vue {
  
  @Prop() public checkedReplenishmentCommodity:Array<Common.StockReplenishmentCommodity>; 

  // ワークフロー処理用プロパティ
  public buttonNames: Array<string> = null;
  public buttonIndexIdArray: Array<{index:number,actionId:number}> =null;
  // 発注処理用プロパティ
  public cpoWorkflowId: number = 0;
  public cpoPic:string = null;
  public cpoSegment:Common.Segment = null;
  public cpoAddExistPurchaseOrder = false;
  public cpoSupplier:Common.Counterpart = null;
  public cpoSupplierEnabled = false;
  public tenantSettings: Common.TenantSettings = null;


  // 発注処理ダイアログの表示
  public mounted(){
    this.tenantSettings = this.$api.tenantSettings;
    // ダイアログ表示前バリデーション
    if(this.checkedReplenishmentCommodity.length == 0){
      this.$api.modal.show('', '対象の商品を選択して下さい。', true, null);
      return;
    }
    // if(this.checkedReplenishmentCommodity.filter(item=>item.commodity.supplier==null).length > 0){
    //   this.$api.modal.show('', '仕入先が設定されている商品を選択して下さい。', true, null);
    //   return;
    // }
    // if(this.checkedReplenishmentCommodity.filter(item=>item.minimumStockQuantity==0).length>0){
    //   this.$api.modal.show('', '補充基準数量が"0"以外の商品のみを選択して下さい。', true, null);
    //   return;
    // }
    // if(this.checkedReplenishmentCommodity.filter(item=>item.replenishmentQuantity==0).length>0){
    //   this.$api.modal.show('', '補充数量が"0"以外の商品のみを選択して下さい。', true, null);
    //   return;
    // }
    // 異なる仕入先が設定されている商品のチェックがONになっている
    var supplierId:number = this.checkedReplenishmentCommodity[0].commodity.supplierId;
    if(this.checkedReplenishmentCommodity.filter(item=>item.commodity.supplierId!=supplierId).length>0){
      this.$api.modal.show('', '仕入先がすべて同一の商品を選択して下さい。', true, null);
      return;
    }
    if(supplierId == null) this.cpoSupplierEnabled = true;
    
    // 発注数量・単位・回答納期・入荷予定日の初期化
    this.checkedReplenishmentCommodity.forEach(obj => {
      obj.purchaseReplenishmentUom = obj.replenishmentUom;
      obj.purchaseReplenishmentQuantity = obj.replenishmentQuantity;
      obj.answerDeliveryDate = new Date().getCalendarDate();
      obj.scheduledDeliveryDate = new Date().getCalendarDate();
    });
    
    // プロパティの初期化
    this.cpoWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_purchaseOrder');
    this.onChangeWorkflow();
    this.cpoPic = this.$api.auth.userId;
    this.cpoSegment = null;
    this.cpoSupplier = null;

    // ダイアログの表示
    (this.$refs.createPurchaseOrderFromCommodityDialog as Components.ListDialog).items = this.checkedReplenishmentCommodity;
    (this.$refs.createPurchaseOrderFromCommodityDialog as Components.ListDialog).showDialog();
  }

  // 発注処理の実行
  public SubmitCreatePurchaseOrder(items:any[], index:number) {
    // クエリの設定
    var query = new Common.CreatePuchaseOrderFromCommodityQuery();
    query.stockReplenishmentCommodityList = this.checkedReplenishmentCommodity;
    query.currencyCode = this.$api.tenantSettings.currencyCode;
    query.pic = this.cpoPic;
    query.segment=this.cpoSegment;
    query.workflowId = this.cpoWorkflowId;
    query.actionId = this.buttonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
    query.addExistPurchaseOrder = this.cpoAddExistPurchaseOrder;
    query.supplier = this.cpoSupplier;
    (this.$refs.createPurchaseOrderFromCommodityDialog as Components.ListDialog).closeDialog();
    return this.$api.execute(query,true).then(res => {
      //トライアル中はロードマップを更新
      if(this.$api.license.isTrial) this.$api.updateRoadmapRatio();      
      var orders = res as Common.Order[];
      var links = orders.map(order=>new Common.ModalLink(order.orderNo,String.format('/purchase/PurchaseOrder?orderNo={0}',order.orderNo)));
      var dialogMessage = '以下の発注伝票が作成・更新されました。';
      if(this.$api.tenantSettings.noCheckPriceRequired == false && orders.filter(order => order.hasNoPriceItem == true).length > 0) dialogMessage += '\r\n※単価の設定がされていない明細があります。';
      if(orders.length == 1){
        this.$api.modal.show('処理結果',dialogMessage,false,()=>{
          var url = String.format('/purchase/PurchaseOrder?orderNo={0}',orders[0].orderNo);
          if (url){ this.$router.push(url);}
        },links,'伝票に移動する','閉じる');
      }else{
        this.$api.modal.show('処理結果',dialogMessage,true,null,links,'閉じる');
      }

// ***** 予定在庫一覧画面からの発注処理成功確認 ※イベント計測は同じ条件でできるよう名称変更しない *****
this.$api.issueGA4trackevent(this.$route.path,'【補充商品一覧】発注処理・成功');

      return true;
    }).catch(()=>{ return false;});      
  }
  public onChangeWorkflow(){
    this.buttonNames=new Array();
    this.buttonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.buttonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.buttonNames.push("発注保存");
    if(this.cpoWorkflowId!=0)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('purchaseOrder', this.cpoWorkflowId, Common.OrderStatus.PurchaseOrderSaving);
      actions.forEach(action => {
        this.buttonNames.push(action.actionName);
        this.buttonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }
  }
public count:number = 0;
  // 単価・税区分を取得する
  public getPriceAndTaxCode(item:Common.StockReplenishmentCommodity){
    this.$api.execute(new StockReplenishmentCommodityGetItemPriceQuery(item,this.cpoSegment,this.cpoSupplier)).then(res => {
      item.unitPrice = res.unitPrice;
      item.taxCode = res.taxCode;
    });
  }
  public getTaxType(item:Common.StockReplenishmentCommodity){
    return item.commodity?.supplier?.taxType ?? this.cpoSupplier?.taxType;
  }
}
class StockReplenishmentCommodityGetItemPriceQuery extends Common.Query{
  constructor(stockReplenishmentCommodity:Common.StockReplenishmentCommodity, segment:Common.Segment, supplier:Common.Counterpart){
    super('StockReplenishmentCommodityGetItemPriceQuery', new Common.ModelBinder(Common.StockReplenishmentCommodity, false));
    this.stockReplenishmentCommodity = stockReplenishmentCommodity;
    this.segment = segment;
    this.supplier = supplier;
  }
  public stockReplenishmentCommodity: Common.StockReplenishmentCommodity;
  public segment: Common.Segment;
  public supplier: Common.Counterpart;
}
</script>







